export default "__VITE_ASSET__BK5ptcH4__"